import { IMessageTemplate } from "../../../components/NewMessageEditors/NewMessageEditorWithMedia/types";

export enum PostState {
  New = 'New',
  Error = 'Error',
  Complete = 'Complete',
  Active = 'Active',
  Deleted = 'Deleted',
  PublishedDeleted = 'PublishedDeleted',
  Rejected = 'Rejected'
}

export enum PostType {
  Poll = 'Poll',
  Post = 'Post',
  Paid = 'Paid',
  Quiz = 'Quiz'
}

export type IPostMessage = {
  type: PostType.Post
  variants: Array<IMessageTemplate>
}

export type PostQuestionnaire = {
  text: string,
  questions: Array<string>,
  is_anonymous: boolean,
  open_period: number | null
  topics?: Array<number>
}

export type PollPost = {
  type: PostType.Poll
  allows_multiple_answers: boolean
} & PostQuestionnaire

export type QuizPost = {
  type: PostType.Quiz
  correct_option_id: string,
  explanation: string
} & PostQuestionnaire

export type PayedPostMessage = {
  type: PostType.Paid
  variants: Array<IMessageTemplate>
  product_id: null | number
  cash_register_id: null | number
}

export enum SplitType {
  None = 'None',
  LastMedia = 'LastMedia',
  Text = 'Text'
}

export type Schedule = {
  run_time: string
  period: Period | null
  timezone: string
}

export type Conditions = {
  type: string
  values: any
}

export type Period = {
  interval: number | null
  unit: string
  conditions: Array<Conditions> | null
}

// delayed_actions/reactions
export const enum PostActionTypeEnum {
  //shared types
  DeletePostAction = 'DeletePostAction',
  EditPostAction = 'EditPostAction',
  SendCommentAction = 'SendCommentAction',
  UnpinChatMessageAction = 'UnpinChatMessageAction',
}

export enum ActionExecuteTypeEnum {
  Serial = 'Serial',
  Parallel = 'Parallel'
}

export type IPostActionStruct = {
  action: Array<any>
}

export type IPostActions = {
  delay: number,
  execute_type: ActionExecuteTypeEnum
} & IPostActionStruct

export type IPostReactions = {
  reaction: string,
  lower_bound: number,
} & IPostActionStruct
